export default function Footer() {
  return (
    <footer className="py-8 border-t border-border">
      <div className="container px-4 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-muted-foreground">
          © {new Date().getFullYear()} Taram. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          <a
            href="mailto:manju@taram.io"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            manju@taram.io
          </a>
          <a
            href="mailto:vinju@taram.io"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            vinju@taram.io
          </a>
          {/* <a
            href="https://taram.io"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Taram.io
          </a> */}
        </div>
      </div>
    </footer>
  );
}
